(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/breadcrumb/breadcrumb.tpl.html',
    '<ol class="breadcrumb"><li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract"><a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel |translate}}</a> <span ng-switch-when="true">{{step.ncyBreadcrumbLabel |translate}}</span></li></ol>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/breadcrumb/breadcrumb.tpl.js